import { createContext, useContext } from 'react';

/**
 * Staff read the Admin Controls queue with scanner terms; merchants read the
 * same proposals from the notifications drawer in plain words.
 */
export type ProposalAudience = 'staff' | 'merchant';

export const ProposalAudienceContext = createContext<ProposalAudience>('staff');

export const useProposalAudience = (): ProposalAudience =>
  useContext(ProposalAudienceContext);
